import httpService from "../httpService";

export default {
  findById(id) {
    return httpService.get(`/hcCaseHotel/${id}`);
  },

  findByHcCaseMaster(hcCaseMasterId) {
    let params = {hcCaseMasterId: hcCaseMasterId};
    return httpService.get("/hcCaseHotel/findByHcCaseMaster", {
      params: params
    });
  },

  create(form) {
    return httpService.post("/khachsan/create", form);
  },

  approve(form) {
    return httpService.post("/khachsan/approve", form);
  },

  update(form) {
    return httpService.post("/khachsan/update", form);
  },

  reject(form) {
    return httpService.post("/khachsan/approve", form);
  },

  cancel(form) {
    return httpService.post("/khachsan/cancel", form);
  }
};



// WEBPACK FOOTER //
// ./src/services/khachsan/hcCaseHotelService.js